import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import { FieldError, inputErrorClass } from '../components/FieldError';
import { BackArrowIcon } from '../components/BackArrowIcon';

export function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errors, setErrors] = useState<Record<string, string>>({});

  const send = async () => {
    setErrors({});
    setSuccess(false);
    if (!email.trim()) {
      setErrors({ email: 'Email is required.' });
      return;
    }
    setLoading(true);
    try {
      await authService.forgotPassword(email.trim());
      setSuccess(true);
    } catch (e: unknown) {
      setErrors({ submit: e instanceof Error ? e.message : 'Failed' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white px-6 py-8 max-w-lg mx-auto">
      <Link
        to="/signin/login"
        className="mb-8 inline-flex items-center gap-1.5 text-sm text-slate-500"
      >
        <BackArrowIcon />
        Back
      </Link>
      <h1 className="text-3xl font-black text-slate-900 mb-2">Forgot Password?</h1>
      <p className="text-slate-500 mb-8">Enter your email and we will send you a code.</p>

      <label className="block text-xs font-black text-blue-600 uppercase mb-2">Email</label>
      <input
        className={`w-full rounded-2xl bg-slate-100 px-4 py-4 mb-1 ${errors.email ? inputErrorClass : ''}`}
        value={email}
        disabled={success}
        onChange={(ev) => setEmail(ev.target.value)}
        type="email"
      />
      <FieldError message={errors.email} />

      {success ? (
        <div className="mt-8">
          <p className="text-emerald-600 text-sm mb-4">Check your email for the 6-digit code.</p>
          <button
            type="button"
            onClick={() => navigate('/reset-password', { state: { email: email.trim().toLowerCase() } })}
            className="w-full py-5 rounded-2xl bg-blue-600 text-white font-black"
          >
            Enter code and set new password
          </button>
        </div>
      ) : (
        <>
          <FieldError message={errors.submit} />
          <button
            type="button"
            disabled={loading}
            onClick={send}
            className="w-full py-5 rounded-2xl bg-blue-600 text-white font-black mt-8 disabled:opacity-50"
          >
            {loading ? '...' : 'Send code'}
          </button>
        </>
      )}
    </div>
  );
}
